import React           from 'react';
import { useSelector } from 'react-redux';

const Blog = () => {
    const blogs = useSelector(state => state.blogState.blogs);

    return (
        <div role="home-blog">
            <article role="content" className="justify-center">
                <div className="content-subTitle">Recent Posts</div>
                <h2 className="content-mainTitle minor-margin--bottom">Our Blog</h2>

                <div className="grid-center-noGutter minor-margin--bottom">
                    <div className="col-8">
                        <p>Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
                    </div>
                </div>

                <div className="grid-center-noGutter">
                    <div className="col-11">

                        <div className="grid">
                            {blogs.map(function(blog, i) {
                                return (
                                    <div className="col-4" key={i}>
                                        <div className="blog-container" style={{backgroundImage: 'url(' + blog.image + ')'}}>
                                            <article className="content">
                                                <div className="blog-container--title">
                                                    <a href={blog.link}>{blog.title}</a>
                                                </div>
                                                <div className="blog-container--excerpt">
                                                    {blog.excerpt}
                                                </div>
                                                <div className="blog-container--more-link">
                                                    <a href={blog.link}>More...</a>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default Blog;
